import { render, staticRenderFns } from "./VoucherModal.vue?vue&type=template&id=028a14b8&scoped=true&"
import script from "./VoucherModal.vue?vue&type=script&lang=js&"
export * from "./VoucherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a14b8",
  null
  
)

export default component.exports